<template>
  <div
    v-if="product && showStickyCta"
    :class="brandClasses.stickyWrapper"
    :style="{ top: stickyHeaderTop }"
  >
    <base-sticky :margin="0" name="stickyProductCta" position="bottom">
      <div :class="brandClasses.stickyLayout" style="min-height: 4rem">
        <base-picture
          v-if="stickyThumbnail?.src"
          :alt="stickyThumbnail.alt"
          class="h-16 w-a shrink-0 <md:hidden"
          :height="stickyHeader?.thumbnail.height"
          :src="stickyThumbnail.src"
          :width="stickyHeader?.thumbnail.width"
        />
        <div :class="brandClasses.stickyProductInfo">
          <span
            :class="brandClasses.stickyProductName"
            data-dynatrace="product-name"
            data-test-id="product-name"
          >
            {{ product.name }}
          </span>
          <product-pricing
            v-if="productPrice"
            :class="brandClasses.stickyProductPrice"
            :currency="product.currency"
            :price="productPrice"
          />
        </div>
        <div :class="brandClasses.stickyCta">
          <product-cta
            :add-to-cart-label="bundleAddToCartLabel"
            :attribute-selection="stickyCtaDisplay.attributeSelection"
            class="flex-1"
            :include-coming-soon="$feature.showComingSoonOnPDP"
            :include-notify-me="$feature.showNotifyMeOnPDP"
            :include-price="$feature.showPriceInCtas && !$viewport.lg"
            include-select-size
            is-sticky
            :loading="addToCartLoading"
            :pending="variantRequestPending"
            :product="stickyCtaDisplay.product"
            :size="{ sm: 'sm', md: 'xs' }"
            @add-to-cart="addToCart"
            @notify-me="handleNotifyMe"
          />
        </div>
      </div>
    </base-sticky>
  </div>
</template>

<script lang="ts" setup>
const config = useAppConfig()
const { brandClasses, showStickyHeader, stickyHeader } = config.pages.pdp
const header = useHeaderStore()
const { $t, $viewport } = useNuxtApp()
const {
  addToCart,
  addToCartLoading,
  bundleItemCount,
  galleryItems,
  handleNotifyMe,
  product,
  productPrice,
  stickyCtaDisplay,
  variantRequestPending
} = usePdp()
const { y } = useScroll(document)
const stickyState = useSticky()

const stickyThumbnail = computed(() => galleryItems.value.find((item) => item.type === 'image' || item.type === 'video'))
const bundleAddToCartLabel = computed(
  () => bundleItemCount.value > 1 ? replaceAll($t.addToCartCount, { count: bundleItemCount.value }) : undefined
)

const { top: productDetailsCtaTop } = useElementBounding(() => stickyState.value.productDetailsCta)

const showStickyCta = computed(() => $viewport.breakpoint === 'sm' || y.value > header.height.navigation)
const stickyHeaderTop = computed(
  () => !showStickyHeader && !header.pageScrolledUp
    ? '0'
    : productDetailsCtaTop.value < 0 && !header.pageScrolledUp
      ? pxToRem(header.sticky.offset)
      : pxToRem(header.sticky.margin)
)
</script>
